import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../context/UserContext';
import { usePostRequest } from '../hooks/request';
import { authLogin } from '../utils/url';
import { LogoSvg } from '../components/Icons';

const LoginPage = () => {
    const loginPost = usePostRequest({ url: authLogin });
    const { loading } = loginPost;
    const { setUser } = useContext(UserContext);
    const navigate = useNavigate();

    const [form] = Form.useForm();

    const formLabel = (title, name) => ({
        label: title,
        name: name,
        rules: [
            {
                required: true,
                message: `Please input your ${name}!`,
            },
        ],
    });

    const formInput = (name) => ({
        placeholder: 'Type here',
        name: name,
    });

    const onFinish = async (values) => {
        const { response } = await loginPost.request({
            data: values,
            sync: true,
        });
        if (response.success) {
            const { accessToken, refreshToken } = response.data.user;
            localStorage.setItem('accessToken', accessToken);
            localStorage.setItem('refreshToken', refreshToken);
            message.success('Success!');
            setUser(true);
            navigate('/');
        }
        if (!response.success) {
            return message.error('Incorrect login or password!');
        }
    };

    return (
        <div className="login">
            <div className="login__card">
                <div className="login__brand">
                    <LogoSvg />
                    <div>
                        <div className="login__title">Welcome back</div>
                        <div className="login__subtitle">
                            Sign in to the admin panel
                        </div>
                    </div>
                </div>
                <Form onFinish={onFinish} form={form} layout="vertical">
                    <Form.Item {...formLabel('', 'username')}>
                        <Input
                            size="large"
                            autoComplete="off"
                            prefix={<UserOutlined />}
                            {...formInput('Username')}
                        />
                    </Form.Item>
                    <Form.Item {...formLabel('', 'password')}>
                        <Input.Password
                            size="large"
                            autoComplete="off"
                            prefix={<LockOutlined />}
                            {...formInput('Password')}
                        />
                    </Form.Item>
                    <Form.Item style={{ marginBottom: 0, marginTop: 8 }}>
                        <Button
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                            size="large"
                            block>
                            Log in
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default LoginPage;
